import LegalPage from "@/components/site/LegalPage";

export default function Terms() {
    return (
        <LegalPage
            title="Terms of Service"
            lastUpdated="December 2026"
            testId="terms-page"
        >
            <p>
                Welcome to CHIGLE. By accessing chigle.co or signing up for our
                early-access waitlist, you agree to the following terms.
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">
                The early-access programme
            </h2>
            <p>
                CHIGLE is currently in a pre-launch phase. Joining the waitlist
                indicates interest in being contacted when we onboard generators,
                collectors, and processors. It does not guarantee participation or any
                specific commercial terms.
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">
                Your information
            </h2>
            <p>
                You agree to provide accurate, current, and complete information when
                you sign up. Treatment of your data is governed by our{" "}
                <a className="text-accent underline-offset-4 hover:underline" href="/privacy">
                    Privacy Policy
                </a>
                .
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">
                Acceptable use
            </h2>
            <ul className="list-disc pl-6 space-y-2">
                <li>Do not submit false or misleading information.</li>
                <li>Do not attempt to disrupt, scrape, or reverse-engineer the site.</li>
                <li>Do not use the platform to handle hazardous or illegal materials.</li>
            </ul>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">
                Intellectual property
            </h2>
            <p>
                The CHIGLE name, logo, copy, design, and source code are owned by CHIGLE
                and protected by applicable copyright and trademark laws. You may not
                copy or reuse them without written permission.
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">
                Limitation of liability
            </h2>
            <p>
                The site and the early-access programme are provided on an "as is"
                basis. To the maximum extent permitted by law, CHIGLE is not liable for
                any indirect, incidental, or consequential damages arising out of your
                use of the site.
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">
                Changes
            </h2>
            <p>
                We may update these terms from time to time. The most recent version
                will always be posted on this page.
            </p>

            <h2 className="font-display text-3xl text-primary mt-10 mb-3">Contact</h2>
            <p>
                Questions? Email{" "}
                <a
                    className="text-accent underline-offset-4 hover:underline"
                    href="mailto:teamchigle@gmail.com"
                >
                    teamchigle@gmail.com
                </a>
                .
            </p>
        </LegalPage>
    );
}
